import { useCallback } from "react";
import axios from "axios";

const useApi = () => {
	const API_KEY = "emJndWxuSzN6bjFjWk1DRWF1VkROOHBITmw2NDF0N2Z5NEowSGtpVg==";
	const fetchApi = useCallback(async (url) => {
		const apiRes = await axios
			.get(url, {
				headers: {
					"X-CSCAPI-KEY": API_KEY,
					redirect: "follow",
				},
			})
			.then((response) => {
				return response.data;
			})
			.catch(console.warn);
		return apiRes;
	}, []);
	return { fetchApi };
};

export default useApi;
